<template lang="pug">
  .imageEditor
    .imageEditor_preview
      .imageEditor_preview_option.mb-6
        p.is-size-4.has-text-weight-bold 編集オプション
          button.ui-tooltip.ml-4(type="button" @click="showOptionDescription = !showOptionDescription")
            b-icon.is-opacity(icon="question-circle" size="is-small")
          p.mb-5.is-size-5(v-if="showOptionDescription")
            | 画像を切り抜くには、画像上をクリックしてからドラッグで範囲を選択してください。<br>
            | 変更を保存した後は画像を元に戻すことができないため、ご注意ください。
        b-button.mt-4.mr-4(type="is-info" size="is-medium" outlined @click="cropImage()") 選択範囲をトリミング
        b-button.mt-4.mr-4(type="is-info" size="is-medium" outlined @click="rotateImage('right')") 右に90°回転
        b-button.mt-4.mr-4(type="is-info" size="is-medium" outlined @click="rotateImage('left')") 左に90°回転
        b-button.mt-4(size="is-medium" @click="setCanvas()") リセット
      b-loading(v-model="canvas.isLoading" :is-full-page="canvas.isFullPage")
      .imageEditor_canvas#canvas-container(:class="{ 'is_loading': canvas.isLoading }")
        canvas#canvas-display.display
        canvas#canvas-drawing.drawing(
          @mousedown="canvasMouseDown($event)"
          @mousemove="canvasMouseMove($event)"
          @touchstart="canvasMouseDown($event)"
          @touchmove="canvasMouseMove($event)")
      .imageEditor_preview_decision.mt-6
        b-button._text_decoration_none.mr-5(
          type="is-text"
          size="is-medium"
          icon-left="arrow-circle-left"
          @click="returnDetail()") 画像詳細に戻る
        b-button(type="is-info" size="is-medium" @click="saveImage()") 変更を保存する
      p.mt-5.is-size-5 ※ 「保存する」ボタンを押さずに画像詳細へ戻ると、編集内容がキャンセルされます
    .imageEditor_panel
      .imageEditor_panel_column
        p.mb-5.is-size-4.has-text-weight-bold 編集情報
        p.mb-4.is-size-5
          span.imageEditor_panel_resize 選択範囲：
            b-input(v-model="canvas.crop.width" size="is-medium" readonly)
            | ×
            b-input(v-model="canvas.crop.height" size="is-medium" readonly)
            | px
        .mb-4.is-size-5
          span 新規サイズ： {{ canvas.size.width }} × {{ canvas.size.height }} px
      .imageEditor_panel_column
        p.mb-5.is-size-4.has-text-weight-bold 画像の縮尺を変更する
          button.ml-4.ui-tooltip(type="button" @click="showResizeDescription = !showResizeDescription")
            b-icon.is-opacity(icon="question-circle" size="is-small")
          p.mb-5.is-size-5(v-if="showResizeDescription")
            | 元の画像のサイズ比率を保ったまま縮尺を変更できます。<br>
            | トリミング、回転の前に縮尺変更を行うことでより良い結果を期待できます。<br>
            | 縮小のみ可能で、拡大はできません。<br>
            | 変更を保存した後は画像を元に戻すことができないため、ご注意ください。
        p.mb-4.is-size-5
          span 元のサイズ： {{ image.size.width }} × {{ image.size.height }} px
        p.mb-4.is-size-5
          span.imageEditor_panel_resize 新規サイズ：
            b-input(v-model="canvas.resize.width" size="is-medium" @input="checkResizeWidth")
            | ×
            b-input(v-model="canvas.resize.height" size="is-medium"  @input="checkResizeHeight")
            | px
            b-icon.ml-3(icon="alert-circle" type="is-danger" v-if="canvas.resize.isDisabled")
          p.mt-2.is-size-5.has-text-danger.has-text-weight-bold(v-if="canvas.resize.isDisabled") {{ canvas.resize.errorMessage }}
        b-button.mt-4(
          type="is-info"
          size="is-medium"
          :disabled="canvas.resize.isDisabled"
          @click="resizeImage()") 縮尺を変更して保存する
</template>

<script>
export default {
  name: 'ImageEditor',
  data: function(){
    return {
      mediaList: new Array(),
      image: {
        data: null,
        size: {
          width: 0,
          height: 0
        },
      },
      canvas: {
        container: null,
        // 画像用キャンバス
        display: null,
        ctxDisplay: null,
        // 選択範囲用キャンバス
        drawing: null,
        ctxDrawing: null,
        ratioX: 0,
        ratioY: 0,
        // キャンバスサイズ
        size: {
          width: 0,
          height: 0,
        },
        // 画像格納
        img: null,
        // 画像の拡張子
        mineType: null,
        // 切り抜き後のサイズ
        crop: {
          width: 0,
          height: 0,
        },
        // リサイズ後のサイズ
        resize: {
          width: 0,
          height: 0,
          isDisabled: false,
          errorMessage: null
        },
        // 選択開始時点の座標
        clickStartX: 0,
        clickStartY: 0,
        // 選択終了時点の座標
        clickEndX: 0,
        clickEndY: 0,
        // 選択範囲用の座標
        selectStartX: 0,
        selectStartY: 0,
        // 選択終了時点の座標
        selectEndX: 0,
        selectEndY: 0,
        // キャンバス内の矩形開始座標（レスポンシブ計算後）
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0,
        // クリック範囲
        clickRange: 16,
        // 範囲選択中か
        selectingRangeFlag: false,
        // 選択範囲の上にカーソルがあるか
        mouseOnStrokeFlag: false,
        // b-loading
        isLoading: false,
        isFullPage: false
      },
      isCardModalActive: false,
      errorMessage: {
        isNaN: '数値は半角数字で入力してください。',
        zero: '数値は1px以上を入力してください。',
        overSize: '画像の拡大はできません。元の画像よりも小さいサイズを指定してください。'
      },
      showOptionDescription: false,
      showResizeDescription: false
    }
  },
  props: [
    'mediaData',
  ],
  mounted() {
    this.setCanvas()
  },
  watch: {
    'canvas.size': {
      handler: function(size) {
        this.canvas.ratioX = this.canvas.display.width / this.canvas.display.clientWidth
        this.canvas.drawing.width = size.width
        this.canvas.container.style.width = ( size.width / this.canvas.ratioX ) + 'px'

        this.canvas.ratioY = this.canvas.display.height / this.canvas.display.clientHeight
        this.canvas.drawing.height = size.height
        this.canvas.container.style.height = ( size.height / this.canvas.ratioY ) + 'px'
      },
      deep: true
    },
    'image.size': {
      handler: function(size) {
        this.canvas.resize.width = size.width
        this.canvas.resize.height = size.height
      },
      deep: true
    },
  },
  methods: {
    returnDetail() {
      this.$emit( 'switchMediaModalPage', 'detail' )
    },
    checkResizeWidth(val) {
      if( isNaN(val) ) {
        this.canvas.resize.isDisabled = true
        this.canvas.resize.errorMessage = this.errorMessage.isNaN
      } else {
        if( val == 0 || val == '' ) {
          this.canvas.resize.isDisabled = true
          this.canvas.resize.errorMessage = this.errorMessage.zero
        } else if ( ( this.image.size.width < val ) || ( this.image.size.height < this.canvas.resize.height ) ) {
          this.canvas.resize.isDisabled = true
          this.canvas.resize.errorMessage = this.errorMessage.overSize
        } else {
          this.canvas.resize.isDisabled = false
        }
        const ratio = val / this.image.size.width
        this.canvas.resize.height =  Math.round( this.image.size.height * ratio )
      }
    },
    checkResizeHeight(val) {
      if( isNaN(val) ) {
        this.canvas.resize.isDisabled = true
        this.canvas.resize.errorMessage = this.errorMessage.isNaN
      } else {
        if( val == 0 || val == '' ) {
          this.canvas.resize.isDisabled = true
          this.canvas.resize.errorMessage = this.errorMessage.zero
        } else if ( ( this.image.size.height < val ) || ( this.image.size.width < this.canvas.resize.width ) ) {
          this.canvas.resize.isDisabled = true
          this.canvas.resize.errorMessage = this.errorMessage.overSize
        } else {
          this.canvas.resize.isDisabled = false
        }
        const ratio = val / this.image.size.height
        this.canvas.resize.width =  Math.round( this.image.size.width * ratio )
      }
    },
    setCanvas(){
      this.canvas.isLoading = true

      this.image.data = this.mediaData.data

      // キャンバスの箱
      this.canvas.container = document.getElementById('canvas-container')

      // キャンバス
      this.canvas.display = document.getElementById('canvas-display')
      this.canvas.drawing = document.getElementById('canvas-drawing')

      // Context
      this.canvas.ctxDisplay = this.canvas.display.getContext('2d')
      this.canvas.ctxDrawing = this.canvas.drawing.getContext('2d')

      this.canvas.img = new Image()
      this.canvas.img.crossOrigin = "anonymous"

      // 画像更新時のキャッシュ対策
      const current_unixtime = Date.now()
      const imgUrl = this.image.data.url + '?time=' + current_unixtime
      this.canvas.img.src = imgUrl

      const fileName = this.image.data.name
      const index = fileName.indexOf('.')
      const extension = fileName.slice(index + 1)

      if ( extension === 'png' ) {
        this.canvas.mineType = 'image/png'
      } else if( extension === 'jpeg' || extension === 'jpg' ) {
        this.canvas.mineType = 'image/jpeg'
      } else if( extension === 'gif' ) {
        this.canvas.mineType = 'image/gif'
      }

      const img = this.canvas.img
      img.onload = () => {
        // 編集前の画像の値を確保
        this.image.size = this.mediaData.size

        const width = img.width
        const height = img.height

        this.canvas.display.width = width
        this.canvas.display.height = height
        this.canvas.drawing.width = width
        this.canvas.drawing.height = height
        //canvas.display,canvas.drawingの値は監視できないため、canvas.size.width,heightも用意して同じ値を格納
        this.canvas.size.width = width
        this.canvas.size.height = height

        this.canvas.ctxDisplay.drawImage(img, 0, 0)

        // 選択範囲キャンバスリセット
        this.canvas.ctxDrawing.clearRect(0, 0, this.canvas.drawing.width, this.canvas.drawing.height)
        this.canvas.startX = 0
        this.canvas.endX = 0
        this.canvas.startY = 0
        this.canvas.endY = 0
        this.canvas.crop.width = 0
        this.canvas.crop.height = 0
        this.canvas.container.style.width = ( this.canvas.size.width / this.canvas.ratioX ) + 'px'
        this.canvas.container.style.height = ( this.canvas.size.height / this.canvas.ratioY ) + 'px'

        this.canvas.isLoading = false
      }
    },
    canvasMouseDown(event){
      this.selectingRangeFlag = true

      const clickX = event.pageX
      const clickY = event.pageY

      const rect = this.canvas.display.getBoundingClientRect()
      const positionX = rect.left + window.pageXOffset
      const positionY = rect.top + window.pageYOffset

      const currentX = clickX - positionX
      const currentY = clickY - positionY

      // 要素内におけるクリック位置を計算
      this.canvas.clickStartX = Math.round( (currentX) * this.canvas.ratioX )
      this.canvas.clickStartY = Math.round( (currentY) * this.canvas.ratioY )

      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('touchmove', this.mouseMove)
      window.addEventListener('mouseup', this.mouseUp)
      window.addEventListener('touchend', this.mouseUp)

    },
    mouseMove(event) {
      // 要素の位置を取得
      const clickX = event.pageX
      const clickY = event.pageY

      const rect = this.canvas.drawing.getBoundingClientRect()
      const positionX = rect.left + window.pageXOffset
      const positionY = rect.top + window.pageYOffset

      const currentX = clickX - positionX
      const currentY = clickY - positionY

      // 対キャンバスの座標（レスポンシブ計算後）
      this.canvas.clickEndX = Math.round( currentX * this.canvas.ratioX )
      this.canvas.clickEndY = Math.round( currentY * this.canvas.ratioY )

      if( this.canvas.clickEndX < 0 && this.canvas.clickEndY < 0 ) {
        // 左上
        this.canvas.clickEndX = 0
        this.canvas.clickEndY = 0
      } else if ( this.canvas.size.width < this.canvas.clickEndX && this.canvas.clickEndY < 0 ) {
        // 右上
        this.canvas.clickEndX = this.canvas.size.width
        this.canvas.clickEndY = 0
      } else if ( this.canvas.size.width < this.canvas.clickEndX && this.canvas.size.height < this.canvas.clickEndY ) {
        // 右下
        this.canvas.clickEndX = this.canvas.size.width
        this.canvas.clickEndY = this.canvas.size.height
      } else if ( this.canvas.clickEndX < 0 && this.canvas.size.height < this.canvas.clickEndY ) {
        // 左下
        this.canvas.clickEndX = 0
        this.canvas.clickEndY = this.canvas.size.height
      } else if ( this.canvas.clickEndY < 0 ) {
        // 上
        this.canvas.clickEndY = 0
      } else if ( this.canvas.size.width < this.canvas.clickEndX ) {
        // 右
        this.canvas.clickEndX = this.canvas.size.width
      } else if ( this.canvas.size.height < this.canvas.clickEndY ) {
        // 下
        this.canvas.clickEndY = this.canvas.size.height
      } else if ( this.canvas.clickEndX < 0 ) {
        // 左
        this.canvas.clickEndX = 0
      }

      if( this.selectingRangeFlag ) {
        // 矩形のリセット
        this.canvas.ctxDrawing.clearRect(0, 0, this.canvas.drawing.width, this.canvas.drawing.height)

        // 矩形のオプション
        this.canvas.ctxDrawing.fillStyle = "rgba(" + [0, 0, 0, 0.6] + ")"
        this.canvas.ctxDrawing.fillRect(0, 0, this.canvas.drawing.width, this.canvas.drawing.height)
        this.canvas.ctxDrawing.strokeStyle = "white"
        this.canvas.ctxDrawing.setLineDash([20, 10])
        this.canvas.ctxDrawing.lineWidth = 4
        // 破線をクリックできる範囲を広げるため
        const _clickRange = this.canvas.clickRange
        // 端まで選択した際に、破線がはみ出ないよう設定
        const _lineWidth = this.canvas.ctxDrawing.lineWidth
        const _harfLineWidth = (this.canvas.ctxDrawing.lineWidth / 2)

        let _width, _height

        // 選択範囲の始点・終点を取得（矩形の左上を始点として、this.canvas.selectStartX or Yに、右下を終点としてthis.canvas.selectendX or Yに代入）
        if( ( this.canvas.startX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.startX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.startY+_clickRange ) ) {
          // 矩形の左上から変形させた場合
          if( this.canvas.clickEndX < this.canvas.endX ) {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.endX
          } else {
            this.canvas.selectStartX = this.canvas.endX
            this.canvas.selectEndX = this.canvas.clickEndX
          }
          if( this.canvas.clickEndY < this.canvas.endY ) {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.endY
          } else {
            this.canvas.selectStartY = this.canvas.endY
            this.canvas.selectEndY = this.canvas.clickEndY
          }
        } else if( ( this.canvas.endX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.startY+_clickRange ) ) {
          // 矩形の右上から変形させた場合
          if( this.canvas.startX < this.canvas.clickEndX ) {
            this.canvas.selectStartX = this.canvas.startX
            this.canvas.selectEndX = this.canvas.clickEndX
          } else {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.startX
          }
          if( this.canvas.clickEndY < this.canvas.endY ) {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.endY
          } else {
            this.canvas.selectStartY = this.canvas.endY
            this.canvas.selectEndY = this.canvas.clickEndY
          }
        } else if( ( this.canvas.endX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.endX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.endY+_clickRange ) ) {
          // 矩形の右下から変形させた場合
          if( this.canvas.startX < this.canvas.clickEndX ) {
            this.canvas.selectStartX = this.canvas.startX
            this.canvas.selectEndX = this.canvas.clickEndX
          } else {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.startX
          }
          if( this.canvas.startY < this.canvas.clickEndY ) {
            this.canvas.selectStartY = this.canvas.startY
            this.canvas.selectEndY = this.canvas.clickEndY
          } else {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.startY
          }
        } else if( ( this.canvas.startX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.startX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.endY+_clickRange ) ) {
          // 矩形の左下から変形させた場合
          if( this.canvas.clickEndX < this.canvas.endX ) {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.endX
          } else {
            this.canvas.selectStartX = this.canvas.endX
            this.canvas.selectEndX = this.canvas.clickEndX
          }
          if( this.canvas.startY < this.canvas.clickEndY ) {
            this.canvas.selectStartY = this.canvas.startY
            this.canvas.selectEndY = this.canvas.clickEndY
          } else {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.startY
          }
        } else if( ( this.canvas.startX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.startY+_clickRange ) ) {
          // 矩形の上から変形させた場合
          this.canvas.selectStartX = this.canvas.startX
          this.canvas.selectEndX = this.canvas.endX
          if( this.canvas.clickEndY < this.canvas.endY ) {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.endY
          } else {
            this.canvas.selectStartY = this.canvas.endY
            this.canvas.selectEndY = this.canvas.clickEndY
          }
        } else if( ( this.canvas.endX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.endY+_clickRange ) ) {
          // 矩形の右から変形させた場合
          if( this.canvas.startX < this.canvas.clickEndX ) {
            this.canvas.selectStartX = this.canvas.startX
            this.canvas.selectEndX = this.canvas.clickEndX
          } else {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.startX
          }
          this.canvas.selectStartY = this.canvas.startY
          this.canvas.selectEndY = this.canvas.endY
        } else if( ( this.canvas.startX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.endX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.endY+_clickRange ) ) {
          // 矩形の下から変形させた場合
          this.canvas.selectStartX = this.canvas.startX
          this.canvas.selectEndX = this.canvas.endX
          if( this.canvas.startY < this.canvas.clickEndY ) {
            this.canvas.selectStartY = this.canvas.startY
            this.canvas.selectEndY = this.canvas.clickEndY
          } else {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.startY
          }
        } else if( ( this.canvas.startX-_clickRange < this.canvas.clickStartX && this.canvas.clickStartX < this.canvas.startX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickStartY && this.canvas.clickStartY < this.canvas.endY+_clickRange ) ) {
          // 矩形の左から変形させた場合
          if( this.canvas.clickEndX < this.canvas.endX ) {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.endX
          } else {
            this.canvas.selectStartX = this.canvas.endX
            this.canvas.selectEndX = this.canvas.clickEndX
          }
          this.canvas.selectStartY = this.canvas.startY
          this.canvas.selectEndY = this.canvas.endY
        } else {
          // 変形ではない矩形選択時
          if( this.canvas.clickStartX < this.canvas.clickEndX ){
            this.canvas.selectStartX = this.canvas.clickStartX
            this.canvas.selectEndX = this.canvas.clickEndX
          } else {
            this.canvas.selectStartX = this.canvas.clickEndX
            this.canvas.selectEndX = this.canvas.clickStartX
          }

          if( this.canvas.clickStartY < this.canvas.clickEndY ){
            this.canvas.selectStartY = this.canvas.clickStartY
            this.canvas.selectEndY = this.canvas.clickEndY
          } else {
            this.canvas.selectStartY = this.canvas.clickEndY
            this.canvas.selectEndY = this.canvas.clickStartY
          }
        }

        _width = this.canvas.selectEndX - this.canvas.selectStartX
        _height = this.canvas.selectEndY - this.canvas.selectStartY

        // 矩形の描画
        this.canvas.ctxDrawing.strokeRect(this.canvas.selectStartX, this.canvas.selectStartY, _width, _height)
        this.canvas.ctxDrawing.clearRect(this.canvas.selectStartX + _harfLineWidth, this.canvas.selectStartY + _harfLineWidth, _width - _lineWidth, _height - _lineWidth)

        this.canvas.crop.width = _width
        this.canvas.crop.height = _height
      }
    },
    canvasMouseMove(event){
      if( !this.selectingRangeFlag ) { // 範囲選択中ではない場合
        this.mouseMove(event) // 座標取得

        const _clickRange = this.canvas.clickRange

        //  カーソルデザイン変更
        if( !( this.canvas.startX == 0 && this.canvas.endX == 0 && this.canvas.startY == 0 && this.canvas.endY == 0 ) ) {
          if ( ( this.canvas.startX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.startX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.startY+_clickRange ) ) {
            // 矩形の左上
            this.canvas.drawing.style.cursor = 'nwse-resize'
          } else if( ( this.canvas.endX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.startY+_clickRange ) ) {
            // 矩形の右上
            this.canvas.drawing.style.cursor = 'nesw-resize'
          } else if( ( this.canvas.endX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.endX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.endY+_clickRange ) ) {
            // 矩形の右下
            this.canvas.drawing.style.cursor = 'nwse-resize'
          } else if( ( this.canvas.startX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.startX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.endY+_clickRange ) ) {
            // 矩形の左下
            this.canvas.drawing.style.cursor = 'nesw-resize'
          } else if( ( this.canvas.startX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.startY+_clickRange ) ) {
            // 矩形の上
            this.canvas.drawing.style.cursor = 'ns-resize'
          } else if( ( this.canvas.endX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.endX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.endY+_clickRange ) ) {
            // 矩形の右
            this.canvas.drawing.style.cursor = 'ew-resize'
          } else if( ( this.canvas.startX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.endX+_clickRange ) && ( this.canvas.endY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.endY+_clickRange ) ) {
            // 矩形の下
            this.canvas.drawing.style.cursor = 'ns-resize'
          } else if( ( this.canvas.startX-_clickRange < this.canvas.clickEndX && this.canvas.clickEndX < this.canvas.startX+_clickRange ) && ( this.canvas.startY-_clickRange < this.canvas.clickEndY && this.canvas.clickEndY < this.canvas.endY+_clickRange ) ) {
            // 矩形の左
            this.canvas.drawing.style.cursor = 'ew-resize'
          } else {
            this.canvas.drawing.style.cursor = 'crosshair'
          }
        } else {
          this.canvas.drawing.style.cursor = 'crosshair'
        }
      }
    },
    mouseUp(){
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('touchmove', this.mouseMove)
      this.selectingRangeFlag = false

      this.canvas.startX = this.canvas.selectStartX
      this.canvas.endX = this.canvas.selectEndX
      this.canvas.startY = this.canvas.selectStartY
      this.canvas.endY = this.canvas.selectEndY

      window.removeEventListener('mouseup', this.mouseUp)
      window.removeEventListener('touchend', this.mouseUp)
    },
    cropImage(){
      if ( !(this.canvas.crop.width === 0 && this.canvas.crop.height === 0) ) {
        const cropWidth = this.canvas.crop.width
        const cropHeight = this.canvas.crop.height

        const img = this.canvas.img

        this.canvas.display.width = cropWidth
        this.canvas.display.height = cropHeight
        this.canvas.size.width = cropWidth
        this.canvas.size.height = cropHeight

        this.canvas.ctxDisplay.drawImage(img, this.canvas.startX, this.canvas.startY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight)
        const base64 = this.canvas.display.toDataURL(this.canvas.mineType)
        this.canvas.img.src= base64
      }
    },
    resizeImage(){
      const resizeWidth = this.canvas.resize.width
      const resizeHeight = this.canvas.resize.height

      this.canvas.display.width = resizeWidth
      this.canvas.display.height = resizeHeight
      this.canvas.drawing.width = resizeWidth
      this.canvas.drawing.height = resizeHeight

      this.canvas.img.src = this.image.data.url
      const img = this.canvas.img
      img.onload = () => {
        this.canvas.ctxDisplay.drawImage(img, 0, 0, resizeWidth, resizeHeight)
        this.saveImage()
      }

      this.canvas.size.width = resizeWidth
      this.canvas.size.height = resizeHeight
    },
    rotateImage(direction) {
      const rotateWidth = this.canvas.display.height
      const rotateHeight = this.canvas.display.width

      let degree
      if(direction === 'right') {
        degree = 90
      } else if (direction === 'left') {
        degree = -90
      }

      const img = this.canvas.img

      this.canvas.display.width = rotateWidth
      this.canvas.display.height = rotateHeight

      this.canvas.ctxDisplay.save()
      this.canvas.ctxDisplay.translate( rotateWidth / 2, rotateHeight / 2 )
      this.canvas.ctxDisplay.rotate( degree * Math.PI / 180 )
      this.canvas.ctxDisplay.translate( -img.width / 2, -img.height / 2 )
      this.canvas.ctxDisplay.drawImage(img, 0, 0)
      this.canvas.ctxDisplay.restore()

      const base64 = this.canvas.display.toDataURL(this.canvas.mineType)
      this.canvas.img.src= base64

      this.canvas.size.width = rotateWidth
      this.canvas.size.height = rotateHeight
    },
    async saveImage() {
      try{
        this.canvas.isLoading = true

        const formData = new FormData()

        const fileName = this.image.data.name
        const base64 = this.canvas.display.toDataURL(this.canvas.mineType)

        const bin = atob(base64.replace(/^.*,/,''))
        const buffer = new Uint8Array(bin.length)
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i)
        }
        const file = new File([buffer.buffer], fileName ,{
          type: this.canvas.mineType
        })
        formData.append('image[image]', file)

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const id = this.image.data.id

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES_.replace(':id', id),
          formData,
          config
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像の変更を保存しました')
          this.$emit( 'getMediaList' )
          this.setCanvas()
          this.image.size.width = this.canvas.display.width
          this.image.size.height = this.canvas.display.height
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像の保存に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.canvas.isLoading = false
      }
    },
  }
}
</script>
